import { BoxContainer, ReactIcons } from "@kalyzee/kalyzee-ui";

import workBoxStyles from "./WorkBox.module.css";

import styles from "./ChatWorkBox.module.css";

export interface ChatWorkBoxProps {
  children: React.ReactNode;
  onClearMessages?: () => void;
}

export const ChatWorkBox = ({
  children,
  onClearMessages,
}: ChatWorkBoxProps) => {
  return (
    <BoxContainer
      style={{ width: "100%", height: "100%" }}
      topBarProps={{
        left: [],
        center: [
          <ReactIcons.ChatBubble style={{ width: 31 }} />,
          <span className={workBoxStyles.label}>Chat</span>
        ],
        right: onClearMessages ? [
          <ReactIcons.Trash 
            className={styles.trash}
            style={{ 
              width: 25, 
              cursor: "pointer",
            }} 
            onClick={onClearMessages} 
          />
        ] : [],
      }}
    >
      {children}
    </BoxContainer>
  );
}